/**
 * Returns an array of ColumnDef(from tanstack) type objects,
 * where each item in column configs array is mapped into a ColumnDef type object with header, accessorKey and meta.
 *
 * @param {ColumnConfigs} columnConfigs
 * @return {ColumnDef<TableData, any>[]}
 */
export var getColumns = function (columnConfigs) {
    return columnConfigs.map(function (column) {
        var header = column.header, accessorKey = column.accessorKey, headerVariant = column.headerVariant, minSize = column.minSize, maxSize = column.maxSize, cell = column.cell;
        return {
            header: header,
            accessorKey: accessorKey,
            cell: cell,
            minSize: minSize,
            maxSize: maxSize,
            meta: {
                headerVariant: headerVariant,
            },
        };
    });
};
//# sourceMappingURL=getColumns.js.map